import { render, staticRenderFns } from "./GenericUserThumbnail.vue?vue&type=template&id=36a2e7a6&scoped=true&"
import script from "./GenericUserThumbnail.vue?vue&type=script&lang=js&"
export * from "./GenericUserThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./GenericUserThumbnail.vue?vue&type=style&index=0&id=36a2e7a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2e7a6",
  null
  
)

export default component.exports